import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import PerformanceSection from "../components/index-components/performance-section"
import RequestDemoSection from "../components/request-demo-section"
import { CaseStudyExploreSection } from "../components/case-study/case-study-section"

import HeroSolutions from "../components/solutions/hero-solutions"
import HowItWorks from "../components/solutions/how-it-works"
import WhySellSide from "../components/solutions/why-sell-side"
import WhoItWorksFor from "../components/solutions/who-it-works-for"
import ImpactSection from "../components/solutions/impact-section"
import OutcomeSection from "../components/index-components/outcome-section"
import PMPLayout from "../components/index-components/pmp-layout"
import PMPHeader from "../components/index-components/pmp-header"

const withLineBreaks = text =>
  typeof text === "string"
    ? text.split("\n").map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && <br />}
          {part}
        </React.Fragment>
      ))
    : text

const asset = relativePath =>
  relativePath ? require(`../images/${relativePath}`) : undefined

const mapPartnerLogos = (logos = []) =>
  logos.map(l => ({ ...l, src: asset(l.src) }))

const mapImpactItems = (items = []) =>
  items.map(it => ({ ...it, src: asset(it.src) }))

const mapSteps = (steps = []) =>
  steps.map(s => ({
    ...s,
    title: withLineBreaks(s.title),
    icon: asset(s.icon),
  }))

const mapWhoCards = (cards = []) =>
  cards.map(c => ({ ...c, icon: asset(c.icon) }))

const SolutionPage = ({ pageContext }) => {
  const {
    slug,
    pageMeta,
    hero,
    impact,
    howItWorksSteps,
    why,
    whoCards,
    ctaFormTitle,
  } = pageContext

  return (
    <PMPLayout showNavigation>
      <SEO title={pageMeta?.title} description={pageMeta?.description} />

      <div className="header-fallback" aria-hidden="true" />
      <PMPHeader />

      <HeroSolutions
        title={hero?.title}
        subtitle={hero?.subtitle}
        heroImg={asset(hero?.heroImg)}
        partnerLogos={mapPartnerLogos(hero?.partnerLogos)}
        cta={hero?.cta}
      />

      <PerformanceSection />

      <hr className="divider" />

      <ImpactSection
        title={impact?.title}
        description={<>{impact?.description}</>}
        items={mapImpactItems(impact?.items)}
      />

      <HowItWorks steps={mapSteps(howItWorksSteps)} />

      <WhoItWorksFor cards={mapWhoCards(whoCards)} />

      <WhySellSide
        leftTitle={why?.left?.title}
        leftItems={mapSteps(why?.left?.items)}
        rightTitle={why?.right?.title}
        rightItems={mapSteps(why?.right?.items)}
        centerResultLines={why?.centerResultLines}
        description={why?.description}
      />

      <CaseStudyExploreSection title="Case Studies" limit={3} />

      <div className="container mt-5">
        <h2 className="has-text-centered is-size-2 is-size-2-mobile has-text-weight-semibold has-text-purple">
          Explore Solutions
        </h2>
        <div className="mt-5 mb-6 px-3">
          <OutcomeSection showDescription={false} />
        </div>
      </div>

      <div id="request-demo">
        <RequestDemoSection
          formPlacement={`Solution Page (/${slug}) - Bottom`}
          ctaFormTitle={ctaFormTitle}
        />
      </div>
    </PMPLayout>
  )
}

export default SolutionPage
